/**
 * Transport HTTP du site public. Seul module autorisé à appeler `fetch` ;
 * reprend le nom de Turbo.FrontEnd (`HttpUtils`) sans ses dépendances.
 */
export abstract class HttpUtils {
  /**
   * Envoie `payload` en JSON vers une URL same-origin sans bloquer la page :
   * `navigator.sendBeacon` d'abord, puis `fetch` keepalive. Les erreurs sont ignorées.
   */
  static sendBeacon(url: string, payload: unknown): void {
    const body = JSON.stringify(payload);

    if (navigator.sendBeacon) {
      const blob = new Blob([body], { type: 'application/json' });
      if (navigator.sendBeacon(url, blob)) {
        return;
      }
    }

    void fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body,
      keepalive: true,
      credentials: 'same-origin'
    }).catch(() => undefined);
  }
}
